import React from "react";
import { Input, FormFeedback } from "reactstrap";
import appConfig from "../../config";

interface MobileInputProps {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  dialcode: string;
  onDialCodeChange?: (dialcode: string, countrycode: string) => void;
  error?: string;
  touched?: boolean;
  placeholder?: string;
}

const MobileInput: React.FC<MobileInputProps> = ({
  name,
  value,
  onChange,
  onBlur,
  dialcode,
  onDialCodeChange,
  error,
  touched,
  placeholder = "Enter your mobile number",
}) => {
  // Get static dial code from config based on environment
  const staticDialCode = appConfig.country.defaultDialCode;
  const staticCountryCode = appConfig.country.defaultCountryCode;

  // Set dial code and country code on mount if not already set
  React.useEffect(() => {
    if (onDialCodeChange && (!dialcode || dialcode !== staticDialCode)) {
      onDialCodeChange(staticDialCode, staticCountryCode);
    }
  }, [staticDialCode, staticCountryCode, dialcode, onDialCodeChange]);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const phoneValue = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange({
      ...e,
      target: { ...e.target, value: phoneValue, name },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="mobile-input-wrapper">
      <div className={`mobile-input-group ${touched && error ? 'has-error' : ''}`}>
        <div className="country-code-static">
          <span className="dial-code-display">{staticDialCode}</span>
        </div>
        <Input
          name={name}
          className="form-control mobile-input"
          placeholder={placeholder}
          type="text"
          onChange={handlePhoneChange}
          onBlur={onBlur}
          value={value}
          invalid={touched && !!error}
        />
      </div>
      {touched && error && (
        <FormFeedback type="invalid" className="error-message">
          {error}
        </FormFeedback>
      )}
    </div>
  );
};

export default MobileInput;

